import { ApplicationCustomerAsHouseOwner } from "@ploy-lib/rest-resources";
import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";
import { HouseOwner } from "@ploy-lib/types";

export class HouseOwnerSchema implements IFormTableSchema<HouseOwner> {
	tableMetadata: TableMetadata<Partial<HouseOwner>> = {};

	columnMetadata: Partial<
		Record<keyof HouseOwner, ColumnMetadata<HouseOwner>>
	> = {
		dateOfBirth: {
			fieldType: FieldType.Date
		},
		isNorwegianCitizen: {
			fieldType: FieldType.Checkbox
		},
		isResident: {
			fieldType: FieldType.Checkbox
		},
		displayValue: {
			fieldType: FieldType.Text
		}
	};
}

export class ApplicationCustomerAsHouseOwnerSchema
	implements IFormTableSchema<ApplicationCustomerAsHouseOwner>
{
	tableMetadata: TableMetadata<Partial<ApplicationCustomerAsHouseOwner>> = {};
	columnMetadata: Partial<
		Record<
			keyof ApplicationCustomerAsHouseOwner,
			ColumnMetadata<ApplicationCustomerAsHouseOwner>
		>
	> = {
		personalNumber: {
			fieldType: FieldType.Text
		},
		phone: {
			fieldType: FieldType.Text
		},
		isResident: {
			fieldType: FieldType.Checkbox
		}
	};
}
